import React from 'react';
import { NextPageContext } from 'next';
import PageLayout from '@/components/Layouts/PageLayout';
import { getBlogDetails } from '@/actions/fetchBlogs';
import getSingleString from '@/utils/string';
import ssrErrorHandler from '@/errors/ssrErrorHandler';
import Container from '@/shared/Container';
import Divider from '@/shared/Divider';
import { useCallback } from 'react';
import MetadataTag from '@/shared/crisp/MetadataTag';
import Map from '@/components/Map';
import date from '@/utils/date';
import Paragraph from '@/shared/Paragraph';
import Heading from '@/shared/Heading';
import Div from '@/shared/Div';
import Picture from '@/shared/Picture';
interface blogPageProps {
  blogData: any;
}

const BlogPage: React.FC<blogPageProps> = ({ blogData }) => {
  const { seo, title, description, tags, mobileImage, desktopImage, publishDate, publishedAt } =
    blogData || {};

  const renderTags = useCallback(
    (Tag: any) => (
      <MetadataTag className="!uppercase !text-white !border-none" key={Tag.label} {...Tag} />
    ),
    [],
  );
  return (
    <PageLayout seo={seo}>
      <Div className="overflow-hidden">
        <Picture
          mobile={mobileImage.data.attributes}
          desktop={desktopImage.data.attributes}
          className="w-full md:mb-s7 mb-s5"
          title={title}
        />
      </Div>
      <Container className="!max-w-5xl">
        <Map
          className="mb-s5 flex items-start h-fit gap-2 flex-wrap"
          list={tags}
          render={renderTags}
        />
        <Div className="font-primary">
          <Heading className="md:text-hd-1 text-h-1">{title}</Heading>
          <Paragraph className="uppercase my-s4 text-body-xs md:text-body-xs-desktop whitespace-nowrap">
            PUBLISHED ON:{' '}
            {date
              .format(publishDate || publishedAt, {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
              .replaceAll(' ', '-')}
          </Paragraph>
          <Divider className="border-b border-neutral-300 md:hidden" />
          <Div
            className="py-s6 blog-detail-page-container"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </Div>
      </Container>
    </PageLayout>
  );
};

export const getServerSideProps = async (nextPageContext: NextPageContext) => {
  try {
    const { query } = nextPageContext;
    const blogId = getSingleString(query.blogId);

    const blogData = blogId ? await getBlogDetails(blogId) : {};

    return {
      props: {
        blogData,
      },
    };
  } catch (error) {
    return ssrErrorHandler(error, nextPageContext);
  }
};

export default BlogPage;
